import DIContainer from 'services/DIContainer';
import { NotificationTemplateResponseDTO } from 'typings/dto/notificationTemplate';
import Mapper from './Mapper';

export default class NotificationTemplateMapper extends Mapper<NotificationTemplate, NotificationTemplateResponseDTO> {
  constructor(private subEntitiesMappers: DIContainer.SubEntitiesMappers) {
    super({
      notificationType: 'notificationType',
      contentMap: 'contentMap',
      tenantId: 'tenantId',
    });
  }

  public responseDTOToModel = (dto: NotificationTemplateResponseDTO): NotificationTemplate => {
    return this.responseDTOToModelViaDiffMap(dto);
  };
}
